module.exports = __webpack_public_path__ + "static/img/call_menu.0d11ba5f.svg";